export default "__VITE_ASSET__DzGGdK18__"